import IconLock from "./icon-lock";
import { HIDDEN_VIDEO_FX_NAMES } from "../constants";
import { buildAudioModes } from "./audio-modes";
import ModeTile from "./mode-tile";

export default function EffectsSection({
  props,
  tileState,
  tileHandlers,
}) {
  const { videoFxs, videoFx, isProFeaturesLocked, onUpgradeClick, onVideoFxChange } =
    props;
  const {
    holdingTileKey,
    draggingTileKey,
    releasingTileKey,
    fillGrowingKeys,
  } = tileState;

  const visibleFxs = videoFxs.filter(
    ({ name }) => !HIDDEN_VIDEO_FX_NAMES.includes(name),
  );
  const audioModes = buildAudioModes(props);

  return (
    <>
      <div className="content__item">
        <div className="content__title">Audio Effects</div>
        <div className="modes-grid modes-grid--audio">
          {audioModes.map((mode) => (
            <ModeTile
              key={mode.key}
              mode={mode}
              isProFeaturesLocked={isProFeaturesLocked}
              holdingTileKey={holdingTileKey}
              draggingTileKey={draggingTileKey}
              releasingTileKey={releasingTileKey}
              fillGrowingKeys={fillGrowingKeys}
              onUpgradeClick={onUpgradeClick}
              {...tileHandlers}
            />
          ))}
        </div>
      </div>
      <div className="content__item">
        <div className="content__title">Video Effects</div>
        <div className="modes-grid">
          {visibleFxs.map(({ value, name }) => {
            const isLocked = isProFeaturesLocked;
            const isActive = videoFx === value;
            return (
              <button
                key={value}
                type="button"
                className={`mode-tile ${!isLocked ? "mode-tile--toggle" : ""} ${isActive ? "mode-tile--active" : ""} ${isLocked ? "mode-tile--locked" : ""}`}
                onClick={() => {
                  if (isLocked) {
                    onUpgradeClick();
                    return;
                  }
                  onVideoFxChange(isActive ? null : value);
                }}
              >
                <span className="mode-tile__label">
                  <span className="mode-tile__label-text">{name}</span>
                </span>
                {isLocked && (
                  <span className="mode-tile__lock-badge" aria-hidden="true">
                    <IconLock />
                  </span>
                )}
              </button>
            );
          })}
        </div>
      </div>
    </>
  );
}
